var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    width: 32,
    height: 32,
    rx: 7.11111,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.634 25.5122V12.3466H6.25794V25.5122H10.6345H10.634ZM8.44688 10.5494C9.97259 10.5494 10.9224 9.53838 10.9224 8.27496C10.8939 6.98275 9.97259 6 8.4759 6C6.97818 6 6 6.98275 6 8.27485C6 9.53827 6.94951 10.5492 8.41821 10.5492H8.44654L8.44688 10.5494ZM13.0562 25.5122H17.4319V18.1607C17.4319 17.7678 17.4605 17.3738 17.5761 17.0931C17.8923 16.3066 18.6123 15.4925 19.8215 15.4925C21.4045 15.4925 22.0382 16.6997 22.0382 18.4697V25.5122H26.4138V17.9635C26.4138 13.9197 24.2552 12.0379 21.3762 12.0379C19.0158 12.0379 17.9791 13.3572 17.4031 14.2558H17.4323V12.347H13.0564C13.1136 13.5821 13.0561 25.5127 13.0561 25.5127L13.0562 25.5122Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.4eebb71f024922f011cfdcf17b7f5899.svg";
export { ForwardRef as ReactComponent };